var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numbervalue"},[_c('div',{staticClass:"numbervalue__num"},[_vm._v(_vm._s(_vm.value))]),(_vm.value)?_c('div',{staticClass:"numbervalue__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }